import axios, { AxiosPromise } from 'axios'

import { ImpressaoAtendimentoInput } from './ImpressaoAtendimentoIndividual'

export class ImpressaoEscutaInicial {
  imprimirEscutaInicial(input: ImpressaoAtendimentoInput): AxiosPromise<Blob> {
    return axios.post('/api/escutaInicial/imprimirEscutaInicial', input, { responseType: 'blob' })
  }
}
